import React, { useCallback } from 'react'
import { Button } from 'reactstrap'
import { Dropzone } from '@/components/fileAttachments/dropzone'
import { format } from '@/utils/StringUtilities'
import { useLocalization } from '@/hooks/localization'

const PrivateKeyDropZone = ({ privateKey, onFileLoaded }) => {
  const { localize } = useLocalization()
  const onDrop = useCallback(files => {
    const file = files[0]
    const reader = new window.FileReader()
    reader.onload = e => onFileLoaded({ file, content: e.target.result })
    reader.readAsText(file)
  }, [onFileLoaded])
  const onClear = useCallback(() => onFileLoaded(null), [onFileLoaded])

  if (privateKey) {
    const { name, size } = privateKey.file
    return <div>{format(localize('Security.PrivateKeyFileFormat'), name, size)} <Button color='primary' onClick={onClear}>{localize('Common.Remove')}</Button></div>
  }
  return <Dropzone uploadButtonText='Security.PrivateKeyDragAndDropText' onDrop={onDrop} />
}

export {
  PrivateKeyDropZone
}



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/xmlSigning/dropzone.js